<div class="sb-simple-navbar--container">
  <div class="sb-simple-navbar--left">
    <div *ngIf="hasBackButton" class="sb-simple-navbar--back-button">
      <i class="sb-back-button color-light codere-icon icon-arrow-left" tappable (click)="navigate()"></i>
    </div>
  </div>
  <div class="sb-simple-navbar--right">
    <ng-content></ng-content>
  </div>
</div>
